module.exports = __webpack_public_path__ + "img/IIM-04.33500037.png";